import { Switch, Route } from 'react-router-dom';
import Validations from 'Containers/Validations';
import PartnerSignIn from 'Containers/Auth/PartnerSignIn';
import PublicRoute from 'Components/PublicRoute';
import PrivateRoute from 'Components/PrivateRoute';
import DefaultRoute from 'Components/DefaultRoute';
import { routes } from 'Constants/routes';
import { AUTH_ROUTES, PRIVATE_ROUTES } from './routes';

const RouteHandler = (): JSX.Element => (
  <Switch>
    {AUTH_ROUTES.map(({ route, component, ...rest }) => (
      <PublicRoute exact path={route} {...rest} component={component} key={route} />
    ))}
    {PRIVATE_ROUTES.map(({ route, component, exact, ...rest }) => (
      <PrivateRoute
        {...rest}
        exact={exact ?? true}
        path={route}
        component={component}
        key={route}
      />
    ))}
    <Route exact path={routes.PARTNER_SIGNIN} render={props => <PartnerSignIn {...props} />} />
    <PrivateRoute exact path={`${routes.VALIDATIONS}/:id`} component={Validations} />
    <DefaultRoute path="*" />
  </Switch>
);

export default RouteHandler;
